module.exports = __webpack_public_path__ + "img/zuijia_10.bb6ccb29.png";